<template>
  <div>
    <div v-if="!editing">
      <template v-if="href">
        <a :href="href">{{ myvalue }}</a>
      </template>
      <template v-else>
        {{ myvalue }}
      </template>
      <span class="is-clickable">&nbsp;
      <i @click="enableEditing" class="fa fa-pencil-alt"></i>
      </span>
    </div>
    <div v-if="editing">
      <input v-model="tempValue" class="input" />
      <button @click="disableEditing">Cancel</button>
      <button @click="saveEdit">Save</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "EditableField",
  data: () => {
    return {
      editing: false,
      tempValue: "",
    };
  },
  props: ["myvalue", "id", "table", "column", "href"],
  methods: {
    ...mapActions({
      updateColumn: "forms/updateColumn",
    }),
    enableEditing: function () {
      this.tempValue = this.myvalue;
      this.editing = true;
    },
    disableEditing: function () {
      this.tempValue = null;
      this.editing = false;
    },
    saveEdit: function () {
      this.myvalue = this.tempValue;

      this.updateColumn({
        table: this.table,
        column: this.column,
        value: this.myvalue,
        id: this.id,
      });

      this.disableEditing();
    },
  },
  mounted() {},
};
</script>

<style scoped>
.is-clickable {
  cursor: pointer;
}</style>
